import { MapTrifold } from '@phosphor-icons/react';
import { useRoutes } from '../hooks/useRoutes';
import { useScrollRestoration } from '../hooks/useScrollRestoration';
import RouteCard from '../components/RouteCard';
import EmptyState from '../components/EmptyState';


// Каркас повторяет плашку маршрута. Подложка — card: на card-secondary
// блоки скелетона лежали цветом в цвет и не были видны вовсе
const RouteCardSkeleton = () => (
  <div className="mb-2 flex items-center gap-3 overflow-hidden rounded-lg border border-theme-border bg-theme-card p-3">
    <div className="animate-shimmer h-[72px] w-[72px] flex-shrink-0 rounded-md" />
    <div className="min-w-0 flex-1">
      <div className="h-4 w-1/2 rounded-sm bg-theme-card-secondary" />
      <div className="mt-2 h-3 w-1/4 rounded-sm bg-theme-card-secondary" />
    </div>
  </div>
);

const RoutesPage = () => {
  useScrollRestoration('/routes');
  const { routes, loading } = useRoutes();

  return (
    <div className="min-h-screen bg-theme-bg pb-6">
      <section
        className="px-4 pb-4"
        style={{ paddingTop: 'calc(var(--safe-area-top) + var(--tg-header-height) + 16px)' }}
      >
        <h1 className="text-h2 text-theme-text-primary">Маршруты</h1>
        <p className="mt-1 text-body-sm text-theme-text-secondary">Готовые прогулки по Петербургу</p>
      </section>

      <div className="px-4">
        {loading && <><RouteCardSkeleton /><RouteCardSkeleton /><RouteCardSkeleton /></>}

        {/* Без кнопки выхода: идти отсюда некуда — маршруты появятся сами,
            когда их заведёт редакция */}
        {!loading && routes.length === 0 && (
          <EmptyState
            icon={MapTrifold}
            title="Маршруты скоро появятся"
            description="Мы готовим интересные прогулки по Петербургу"
          />
        )}

        {!loading && routes.map(route => <RouteCard key={route.id} route={route} />)}
      </div>
    </div>
  );
};

export default RoutesPage;
